export default {
  title: 'LA PAGINA CHE CERCHI DEVE ESSERE DA QUALCHE PARTE...',
  description: 'Stai cercando una di queste pagine?',
  not_found: "Non riusciamo a trovare l'URL inserito. Controlla che sia corretto.",
  no_restaurants: {
    title: 'Questo locale non accetta ancora ordini online',
    description: 'Riprova a breve.',
  },
  toasts: {
    failed_to_load_stores: 'Impossibile caricare i negozi, aggiorna la pagina',
  },
};
